module.exports = __webpack_public_path__ + "static/Reimagine with AI Services - Banner image-74fe497ab1a5af6ba5b873372d87b3a4.png";